import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-report-menu',
  templateUrl: './report-menu.component.html',
  styleUrls: ['./report-menu.component.css']
})
export class ReportMenuComponent implements OnInit {

  menuList:any;
  pageList:any;

  constructor() { }

  ngOnInit() {
    this.menuList=localStorage.getItem('menuList');
    this.menuList=JSON.parse(this.menuList);
    for(let i=0; i<this.menuList.length; i++){
      if(this.menuList[i].KHB_MenuName=='Reports')
        this.pageList=this.menuList[i].KHB_PagesList;
    }
  }

}




// WEBPACK FOOTER //
// ./src/app/reports/report-menu/report-menu.component.ts